import { Component as EcsyComponent, TagComponent as EcsyTagComponent, Types as EcsyTypes } from "ecsy";

export class Selected extends EcsyTagComponent { }

export class Select extends EcsyComponent<Select> {
}

Select.schema = {
}